import { useCallback, useState } from "react";

/**
 * Keeps a modal that mounts only on demand mounted through its close
 * animation. `subject` is what the modal shows while it's open and null once
 * it closes; `mountedSubject` keeps the last one until the modal's
 * `onExited`, so render the modal while it's set with `show={isOpen}`.
 */
export const useOnDemandModal = <TSubject>(subject: TSubject | null) => {
    const [mountedSubject, setMountedSubject] = useState(subject);
    if (subject !== null && subject !== mountedSubject) {
        setMountedSubject(subject);
    }
    const onExited = useCallback(() => setMountedSubject(null), []);
    return { mountedSubject, isOpen: subject !== null, onExited };
};
